import React, { useEffect, useState } from "react";
import { FaWhatsapp } from "react-icons/fa";
import Collapse from "../../components/atoms/colapso";
import Footer from "../../components/organisms/footer";
import NavBar from "../../components/organisms/navbar";
import { FaMapMarkerAlt } from 'react-icons/fa';
//import useAuthenticate from "../../hooks/useAuthenticate";
import {
  Container,
  Content,
  H3,
  H5,
  Location,
  P,
  QRCodeImg,
  Span,
  Title,
  TournamentActions,
  TournamentBanner,
  TournamentContainer,
  TournamentContainerBanner,
  TournamentContent,
  TournamentDescription,
  TournamentEnrollmentLink,
  TournamentEnrollmentLinkEndpage,
  TournamentLink,
  EditalContainer,
  EditalContent,
  EditalTitle
} from "./styles";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import api from "../../services/api";
import Swal from "sweetalert2";
// import tabelaPeso from "../../assets/images/tournaments/toledo-international-open-brazilian-jiu-jitsu-2023/tabepla-de-peso.jpeg";
import tabelaPeso from "../../assets/images/tournaments/noroeste-open-de-jiu-jitsu-2025/tabela-noroeste-open-de-jiu-jitsu-2025.jpg";
import qrCodecopaAmizadeDeJiuJitsu2024 from "../../assets/images/tournaments/copa-amizade-de-jiu-jitsu-2024/qr-coce--copa-amizade-de-jiu-jitsu-2024.jpg";

//Patrocinio
import torneio from "../../assets/images/sponsors/torneio-facil.png";
import autoPostoCarretao from "../../assets/images/sponsors/postoCarretao.png";
import titans from "../../assets/images/sponsors/titans-mecanica-a-diesel.jpeg";
import paulinhoPneus from "../../assets/images/sponsors/paulinho-pneus.png";
import mundoMedico from "../../assets/images/sponsors/mundo-medico-produtos-hospitalares.jpg";
import xport from "../../assets/images/sponsors/export-nutricao.png";
import neocampo from "../../assets/images/sponsors/neocampo.jpeg";
import siot from "../../assets/images/sponsors/siot.png";
import laboderm from "../../assets/images/sponsors/laborderm-farmacia.png";
import apiensColegio from "../../assets/images/sponsors/apeins-colegio.jpeg";
import energyDrink from "../../assets/images/sponsors/energy-drink.jpeg";
import unimed from "../../assets/images/sponsors/unimed.jpeg";
import refrigeranteabaGold from "../../assets/images/sponsors/refrigerante-aba-gold.png";
import stormstrong from "../../assets/images/sponsors/stormstrong.jpeg";



//Apoio
import trevusMartialArts from "../../assets/images/sponsors/trevus-martial-arts.jpg";
import { SponsorContainer, SponsorList } from "src/components/atoms/sponsor-area/styles";
import SponsorButton from "src/components/atoms/sponsor-area";
import useAuthenticate from "../../hooks/useAuthenticate";


const sponsors = [
  { img: autoPostoCarretao, url: "" },
  { img: apiensColegio, url: "" },
  { img: xport, url: "" },
  { img: laboderm, url: "" },
  { img: neocampo, url: "" },
  { img: titans, url: "" },
  { img: paulinhoPneus, url: "" },
  { img: mundoMedico, url: "" },
  { img: siot, url: "" },
  { img: energyDrink, url: "" },
  { img: unimed, url: "" },
  { img: refrigeranteabaGold, url: "" },
  { img: stormstrong, url: "" },
  
];


const support = [

  { img: torneio, url: "http://www.torneiofacil.com" },
];


const cacheBuster = `?cacheBuster=${new Date().getTime()}`
const dataEvento = "30 de novembro de 2025 "
const horaEvento = "9:00h da manhã"
const tituloEvento = "Noroeste Open de Jiu Jitsu 2025"
const localEvento = "Ginásio de Esportes Amário Vieira da Costa"
const endereçoEvento = "Av. Gov. Parigot de Souza, 4284-4454 - Zona I, Umuarama - PR,CEP 87503-680"
const dataDeEncerramentoIncricao = "27/NOV/2025"
const horaDeEncerramentoIncricao = "23h:59"

const dataDeEncerramentoCorrecao = "27/NOV/2025"
const horaDeEncerramentoCorrecao = "23h:59min"

const dataDeEncerramentoInscricaoLoteUnico = "27/NOV/2025"

const valorinscricaoCategoriaLoteUnico = "150,00 (cento e cinquenta reais)"
const valorinscricaoLoteUnicoComboGieNogi = "250,00 (duzentos e cinquenta reais)"

const dataDeDivulgacaoChaves = "29/NOV/2025"
const horaDeDivulgacaoChaves = "23h:59min"

const instituicaoBancaria = "SICOOB";
const tipoDeChavePix = "CELULAR";
const ChavePix = "44999991141";
const BeneficiarioDaChavePix = "Luiza Carlini Francisco";

const dataDeDivulgacaoCronograma = " "
const horaDeDivulgacaoCCronograma = " "

const contatoWhatsApp = "+55 (44) 99726-9732"
const contatoWhatsAppTorneio = "+55 (11) 94456-3515"

const slugGI = "noroeste-open-de-jiu-jitsu-2025-umuarama-pr-gi";
const slugNOGI = "noroeste-open-de-jiu-jitsu-2025-umuarama-pr-nogi";
const rotaInscriçãoGi = `/enrollment/noroeste-open-de-jiu-jitsu-2025-umuarama-pr-gi`;
const rotaChecagemGi = "/check/noroeste-open-de-jiu-jitsu-2025-umuarama-pr-gi/search";
const rotaChecagemNogi = "/check/noroeste-open-de-jiu-jitsu-2025-umuarama-pr-nogi/search";
const rotaChavesGI = "/tournament/keys/noroeste-open-de-jiu-jitsu-2025-umuarama-pr-gi"
const rotaChavesNogi = "/tournament/keys/noroeste-open-de-jiu-jitsu-2025-umuarama-pr-nogi"



const NoroesteOpenDeJiuJitsu2025: React.FC = () => {


  const { authenticated } = useAuthenticate();
  const navigate = useNavigate();
  const [tournamentGI, setTournamentGI] = useState<any>();
  const [tournamentNOGI, setTournamentNOGI] = useState<any>();

  useEffect(() => {
    api.get(`/tournaments/${slugGI}`).then(({ data }) => {
      setTournamentGI(data);
    });

    api.get(`/tournaments/${slugNOGI}`).then(({ data }) => {
      setTournamentNOGI(data);
    });
  }, []);

  const handleToSubscriptionPage = (url: string) => {
    if (tournamentGI!.canSubscribe || tournamentNOGI!.canSubscribe) {
      navigate(url);
      return;
    }

    const msg = "Período de inscrição encerrado.";

    Swal.fire({
      title: 'Atenção!',
      text: msg,
      icon: 'error',
    });

    toast.error(msg);
  }
  return (
    <>
      <NavBar />

      <Container>
        <TournamentContainer
          image={require("../../assets/images/tournaments/noroeste-open-de-jiu-jitsu-2025/noroeste-open-de-jiu-jitsu-2025-tournament.jpeg")}
        >
          <TournamentContainerBanner>
            <TournamentBanner
              image={require("../../assets/images/tournaments/noroeste-open-de-jiu-jitsu-2025/noroeste-open-de-jiu-jitsu-2025-tournament.jpeg")}
            />
          </TournamentContainerBanner>
        </TournamentContainer>
        <TournamentContent>
          <Content>
            <Title>{tituloEvento}</Title>
            <Location>
              <Span>Data: {dataEvento}</Span>
              <Span>Início: {horaEvento}</Span>
              <Span>Local: {localEvento}</Span>
              <Span>Endereço: {endereçoEvento}</Span>
              <Span>
                <div style={{ display: 'flex', alignItems: 'center', marginTop: '10px' }}>
                  <FaMapMarkerAlt style={{ marginRight: '8px', color: "red" }} />
                  <a
                    target={"blank"}
                    style={{ color: "#000", textDecoration: "none", fontWeight: "bold" }}
                    href="https://maps.app.goo.gl/gJPnjhrjfwBrUa468"
                  >
                    Ver no Google Maps
                  </a>
                </div>
              </Span>
            </Location>
            <P></P>
            <br />

          </Content>
        </TournamentContent>
        <TournamentDescription>
          <TournamentActions>
            <Content>
              <h1 style={{ textAlign: "center" }}>PATROCINADORES</h1>
              <SponsorContainer>
                <SponsorList>
                  {sponsors && sponsors.map((buttons: any, index: number) => (
                    <SponsorButton
                      key={index} // Adicionei uma chave única para cada botão
                      img={buttons.img}
                      url={buttons.url}
                      hasError={false}
                      error="Este campo é obrigatório"
                      target="_blank" // Adicione este atributo
                    />
                  ))}
                </SponsorList>
              </SponsorContainer>
              <h1 style={{ textAlign: "center" }}>APOIO</h1>
              <SponsorContainer>
                <SponsorList>
                  {support &&
                    support.map((buttons: any) => (
                      <SponsorButton
                        img={buttons.img}
                        url={buttons.url}
                        hasError={false}
                        error="Este campo é obrigatório"
                      />
                    ))}
                </SponsorList>
              </SponsorContainer>
            </Content>

            <Content style={{
              marginTop: '32px'
            }}>

              <EditalContainer>
                <EditalTitle>EDITAL {tituloEvento.toLocaleUpperCase()}</EditalTitle>
                <EditalContent>
                  <Span>
                  O {tituloEvento} é um evento tradicional  que
                      fomenta e incentiva a prática do jiu jitsu no estado do Paraná. As lutas
                      serão GI (com kimono) e NOGI (sem kimono), o evento disponibilizará
                      categorias para todas as idades e faixas, conforme a tabela de peso
                      deste edital. Os competidores terão a oportunidade de testar suas
                      habilidades em um ambiente controlado e com acompanhamento de
                      profissionais qualificados.
                  </Span>
                  <br />
                  <br />
                  <br />
                </EditalContent>

          {/*       <Collapse title="PROTOCOLO DE SEGURANÇA CONTRA COVID-19">
                  <P>
                    Devido a dinâmica da situação atual, estamos avaliando diariamente as
                    recomendações dos Órgãos de Saúde e este protocolo pode ser atualizado a
                    qualquer momento caso novas determinações sejam publicadas.
                  </P>
                  <P>
                    Caso o evento seja cancelado por força maior, todas as inscrições serão
                    automaticamente reembolsadas.
                  </P>
                  <P>
                    A organização não é responsável pelos demais custos dos participantes,
                    tais como transporte e hospedagem.
                  </P>
                  <P>
                    Diretrizes do ginásio: Para a segurança de todos, por favor verifique
                    sua temperatura antes de se dirigir ao evento.{" "}
                  </P>
                  <P>Caso haja qualquer sintoma, procure um médico.</P>{" "}
                  <P>
                    {" "}
                    Caso você se sinta indisposto ou esteve em contato com um paciente
                    diagnosticado com Covid-19, por favor fique em casa e procure seu
                    médico.
                  </P>
                   <P>
                  Todo nosso material será desinfetado antes e durante o evento.
                </P> 
                </Collapse> */}
                <Collapse title="PREMIAÇÕES MEDALHAS🥇 +KIMONOS🥋 +DINHEIRO💰">
                    {/*      <H3>Academias:</H3>
                  <P>1° lugar: Troféu 🏆</P>
                  <P>2° lugar: Troféu 🏆</P>
                  <P>3° lugar: Troféu 🏆</P>
                  */}


                    <H3>Absoluto Masculino GI:</H3>

                    <H5>Juvenil Branca</H5>
                    <P>1° lugar: 1 Kimono Stormstrong + Medalha 🥇</P>
                    <P>2° lugar: Medalha🥈 </P>
                    <P>3° lugar: Medalha🥉</P>

                    <H5>Juvenil Graduado</H5>
                    <P>1° lugar: 1 Kimono Stormstrong + Medalha 🥇</P>
                    <P>2° lugar: Medalha🥈 </P>
                    <P>3° lugar: Medalha🥉</P>

                    <H5>Adulto Branca</H5>
                    <P>1° lugar: 1 Kimono Stormstrong + Medalha🥇</P>
                    <P>2° lugar:Medalha🥈 </P>
                    <P>3° lugar: Medalha🥉</P>

                    <H5>Adulto Azul</H5>
                    <P>1° lugar: R$ 400,00 + Medalha 🥇</P>
                    <P>2° lugar: Medalha🥈 </P>
                    <P>3° lugar: Medalha🥉</P>

                    <H5>Adulto Roxa</H5>
                    <P>1° lugar: R$ 500,00 + Medalha 🥇</P>
                    <P>2° lugar: Medalha🥈 </P>
                    <P>3° lugar: Medalha🥉</P>

                    <H5>Adulto Marrom</H5>
                    <P>1° lugar: R$ 600,00 + Medalha 🥇</P>
                    <P>2° lugar: Medalha🥈 </P>
                    <P>3° lugar: Medalha🥉</P>

                    <H5>Adulto/master(juntos) Preta</H5>
                    <P>1° lugar: R$ 1.000,00 + Medalha 🥇</P>
                    <P>2° Medalha🥈 </P>
                    <P>3° lugar: Medalha🥉</P>

                    <br />
                    <br />
                    <H3>Absoluto Feminino GI:</H3>

                    <H5>Juvenil (todas as faixas juntas)</H5>
                    <P>1° lugar: 1 Kimono Stormstrong + Medalha 🥇</P>
                    <P>2° lugar:Medalha🥈 </P>
                    <P>3° lugar: Medalha🥉</P>

                    <H5>Adulto Branca</H5>
                    <P>1° lugar: 1 Kimono Stormstrong +  Medalha 🥇</P>
                    <P>2° lugar:Medalha🥈 </P>
                    <P>3° lugar: Medalha🥉</P>

                    <H5>Adulto/master Azul/Roxa (juntas)</H5>
                    <P>1° lugar: R$ 300,00 + Medalha 🥇</P>
                    <P>2° lugar: Medalha🥈 </P>
                    <P>3° lugar: Medalha🥉</P>

                    <H5>Adulto/Master Marrom/Preta (juntas)</H5>
                    <P>1° lugar: R$ 500,00 + Medalha 🥇</P>
                    <P>2° lugar:Medalha🥈 </P>
                    <P>3° lugar: Medalha🥉</P>
                    <br />

                    <H3>Absoluto Masculino NOGI:</H3>

                    <H5>Juvenil (todas as faixas juntas)</H5>
                    <P>1° lugar: 1 Kimono Stormstrong + Medalha 🥇</P>
                    <P>2° lugar:Medalha🥈 </P>
                    <P>3° lugar: Medalha🥉</P>

                  {/*   <H5>Adulto Branca</H5>
                    <P>1° lugar: R$ 300,00 + Medalha🥇</P>
                    <P>2° lugar:Medalha🥈 </P>
                    <P>3° lugar: Medalha🥉</P> */}

                    <H5>Adulto Azul e Roxa - (Juntos)</H5>
                    <P>1° lugar: R$ 600,00 + Medalha 🥇</P>
                    <P>2° lugar: Medalha🥈 </P>
                    <P>3° lugar: Medalha🥉</P>

                    <H5>Adulto/master Marrom/Pretas (Juntos)</H5>
                    <P>1° lugar: R$ 800,00 + Medalha 🥇</P>
                    <P>2° Medalha🥈 </P>
                    <P>3° lugar: Medalha🥉</P>

                    <br />
                    <br />
                    <H3>Absoluto Feminino NOGI:</H3>

                    <H5>Juvenil (todas as faixas juntas)</H5>
                    <P>1° lugar: 1 Kimono Stormstrong + Medalha 🥇</P>
                    <P>2° lugar:Medalha🥈 </P>
                    <P>3° lugar: Medalha🥉</P>

                   {/*  <H5>Adulto Branca</H5>
                    <P>1° lugar: R$ 200,00 +  Medalha 🥇</P>
                    <P>2° lugar:Medalha🥈 </P>
                    <P>3° lugar: Medalha🥉</P> */}

                    <H5>Adulto/master Azul/Roxa (juntas)</H5>
                    <P>1° lugar: R$ 300,00 + Medalha 🥇</P>
                    <P>2° lugar: Medalha🥈 </P>
                    <P>3° lugar: Medalha🥉</P>

                    <H5>Adulto/Master Marrom/Preta (juntas)</H5>
                    <P>1° lugar: R$ 500,00 + Medalha 🥇</P>
                    <P>2° lugar:Medalha🥈 </P>
                    <P>3° lugar: Medalha🥉</P>
                    <br />

                    <P>Para a realização de lutas na categoria absoluto, é exigido um mínimo de 4 atletas inscritos.</P>
                    <P>A premiação nas categorias absoluto será efetuada somente se o número de participantes atingir o mínimo de 8 inscritos.</P>
                    <P>Número menor que 8 atletas a premiação ficará a critério da organização do evento, podendo não ter premiação. </P>
                    <br />

                    <H3>Demais Categorias GI</H3>
                    <P>1° lugar: Medalha 🥇</P>
                    <P>2° lugar: Medalha🥈 </P>
                    <P>3° lugar: Medalha🥉</P>

                    <br />
                  </Collapse>

                <Collapse title="INSCRIÇÕES">
                  <Span>
                    As inscrições para o evento serão realizadas exclusivamente online, por
                    meio do site www.torneiofacil.com.br
                  </Span>
                  <P>
                    Durante o processo de inscrição, o atleta ou seu responsável legal
                    deverá selecionar corretamente a categoria referente idade que o atleta
                    completará no ano de 2025, bem como sua faixa e peso.
                  </P>
                  <P>
                    A idade de competição do atleta é a idade máxima que ele terá em 2025,
                    conforme regra da CBJJ.
                  </P>
                  <br />
                  <H3>Prazo de Inscrição</H3>
                  <P>
                    O prazo final para inscrições e pagamento será até  {dataDeEncerramentoIncricao}, às {""}
                    {horaDeEncerramentoIncricao}min.
                  </P>
                  <br />
                  <P>As inscrições que não forem pagas serão canceladas.</P>
                  <br />
                  {/* <H3>Valor  </H3>
                  <P>Primeiro Lote até {dataDeEncerramentoInscricaoLote1}</P>
                  <P>Inscrição categoria R$ {valorinscricaoCategoriaLote1} (quarenta reais)</P>
                  <P>Inscrição absoluto R$ {valorinscricaoCategoriaAbsoluto} (trinta reais)</P>
                  <br />
                  <P>Segundo Lote até {dataDeEncerramentoInscricaoLote2}</P>
                  <P>Inscrição categoria R$ {valorinscricaoCategoriaLote2} (cinquenta reais)</P>
                  <P>Inscrição absoluto R$ {valorinscricaoCategoriaAbsoluto} (trinta reais)</P>
                  <P>Inscrição Combo categoria + absoluto R$ {valorinscricaoLote2ComboGieAbsoluto} (setenta reais)</P>

                  <br />
                  <P>Terceiro Lote até {dataDeEncerramentoInscricaoLote3}</P>
                  <P>Inscrição categoria R$ {valorinscricaoCategoriaLote3} (cinquenta reais)</P>
                  <P>Inscrição absoluto R$ { valorinscricaoCategoriaAbsolutoLote3} (quarenta reais)</P>
                  <P>Inscrição Combo categoria + absoluto R$ {valorinscricaoLote3ComboGieAbsoluto} (cem reais)</P>
                  <br /> */}

                  <H3>Correção</H3>
                  <P>
                    A correção da inscrição poderá ser realizada somente após a confirmação
                    do pagamento.
                  </P>
                  <P>
                    Em caso de inscrição equivocada, o atleta ou professor responsável
                    poderá corrigir as informações no site www.torneiofacil.com.br,
                    acessando a opção Meu Perfil em seguida Minhas Inscrições.
                  </P>
                  <P>
                    A correção da inscrição ficará disponível até o encerramento das
                    inscrições {dataDeEncerramentoCorrecao} às {horaDeEncerramentoCorrecao}.
                  </P>
                  <P>
                    Após prazo para correção das inscrições, não serão aceitas modificações
                    nas inscrições.
                  </P>
                  <P>
                    Os atletas que se inscreverem incorretamente estarão sujeitos a
                    desclassificação <b>sem direito a reembolso.</b>
                  </P>
                  <br />
                  <H3>Prazo de Correção</H3>
                  <P>
                    A correção da inscrição fica disponível após a confirmação do pagamento
                    da mesma.
                  </P>
                  <P>
                    A correção da inscrição ficará disponível até o encerramento das
                    inscrições {dataDeEncerramentoCorrecao} as {horaDeEncerramentoCorrecao}.
                  </P>
                  <br />
                  <H3>Checagem</H3>
                  <P>
                    O sorteio e divulgação das chaves de lutas será em {dataDeDivulgacaoChaves} até às {horaDeDivulgacaoChaves}.
                  </P>
                  <br />
                  <H3>Inscrição de Absoluto</H3>
                  <P>
                    Somente atletas inscritos na categoria poderão se increver e participar
                    do absoluto.
                  </P>
                  <P>
                    Os atletas só poderão se inscrever no absoluto referente a categoria da
                    sua inscrição no torneio. Exceção apenas para os master que poderá se
                    inscrever como absoluto adulto.
                  </P>
                </Collapse>
                <Collapse title="PESSOAS COM DEFICIÊNCIA (PCD)">
                  <H3>
                    As pessoas com deficiência (PCD) devem informar, no momento da
                    inscrição, sua condição pelo WhatsApp. Caso contrário o atleta será
                    desclassificado sem direito a reembolso.
                  </H3>

                  <br />
                </Collapse>

                <Collapse title="VALOR DA INSCRIÇÃO">
                  <Span>
                    As inscrições serão em lote único:
                  </Span>
                  <H3>Lote Único até {dataDeEncerramentoInscricaoLoteUnico}</H3>
                  <P>Inscrição categoria GI ou NOGI R$ {valorinscricaoCategoriaLoteUnico} </P>
                  <P>Inscrição Combo categoria GI + NOGI  R$ {valorinscricaoLoteUnicoComboGieNogi} </P>
            
                  <br />


                </Collapse>
                <Collapse title="PAGAMENTO">
                    <H3>
                      A confirmação de pagamento deve ser feita pelo envio do comprovante via WhatsApp para o contato abaixo.
                    </H3>
                    <H3>
                      Caso o atleta não envie o comprovante de pagamento e o número de sua inscrição até o fim do período de
                      inscrições {/* ({dataDeEncerramentoInscricaoLote1}) */}, ele será desclassificado sem direito a reembolso.
                    </H3>
                    <P>Banco: {instituicaoBancaria}</P>
                    <P>Titular: {BeneficiarioDaChavePix}</P>
                    <P>Tipo de chave PIX: {tipoDeChavePix}</P>
                    <P>Chave PIX: {ChavePix}</P>
                    {/* <QRCodeImg src={qrCodecopaAmizadeDeJiuJitsu2024} alt="qrCode" width={300} />
                  <P>
                    <a
                      target={"blank"}
                      style={{ color: "white" }}
                      href="https://whatsa.me/5592981291027/?t=Ol%C3%A1+Thiago_Dellarmelina%2C+vou+enviar+o+comprovante+de+pagamento+referente+a+inscri%C3%A7%C3%A3o+na+%2ACOPA+ORLEY+LOBATO+DE+JIU+JITSU+2024%2A"
                    >
                      <strong>WhatsApp: +55 (92) 98129-1027 </strong>
                      <FaWhatsapp />
                    </a>
                  </P> */}
                    <p />
                    {/* <QRCodeImg src={qrCodeCopaParana} alt="qrCode" width={300} /> */}
                  </Collapse>
                  <Collapse title="CATEGORIAS COM APENAS UM COMPETIDOR (SEM LUTA)">
                    <Span>
                      Atletas que estiverem sozinhos na categoria terão 02 opções:
                    </Span>
                    <P>
                      Permanecer sozinho na categoria, ser campeão e medalhar sem lutar;
                    </P>
                    <P>Mudar de categoria até a data de encerramento das inscrições;</P>
                    <P>NÃO HAVERÁ LUTAS CASADAS NESSE EVENTO</P>
                  </Collapse>
                <Collapse title="REEMBOLSO DAS INSCRIÇÕES">
                  <H3>
                    Em caso de Lesão ou doença , o atleta poderá solicitar o reembolso da
                    inscrição, sendo obrigatório a comprovação e apresentação de atestado
                    médico.
                  </H3>
                  <H3>
                    Após o fim do período de inscrição não será possível o reembolso das
                    inscrições pagas.
                  </H3>
                </Collapse>

                <Collapse title="REGRAS">

                  <Span>
                    Todas as regras para o evento estão devidamente estipuladas e detalhadas neste edital.
                  </Span>
                  <Span>
                    Em casos de omissão de regras no presente edital, as normas a serem observadas serão aquelas estabelecidas pela Confederação
                    Brasileira de Jiu-Jitsu (CBJJ), em conformidade com as diretrizes da CBJJ/IBJJF.
                  </Span>
                  <Span>
                    A tabela de peso por categoria, que estabelece os limites de peso para cada categoria, encontra-se disponível no site oficial do evento,
                    acessível por meio do botão denominado "Tabela de Peso".
                  </Span>
                  <Span>
                    As lutas serão com GI (com kimonos de cores Oficiais pela cbjj branco,
                    azul e preto ) os kimonos devem estar limpos sem rasgos e sem odor .
                  </Span>
                  {/* <Span>
                    Para categoria com 3 lutadores, o lutador que ficar sozinho no sorteio da chave estará automaticamente na final.
                    Em caso de WO de um atleta, os dois lutadores restantes na categoria disputarão a final.
                  </Span> */}
                   <Span>
                      Haverá premiação em dinheiro para o primeiro lugar , somente na
                      categoria absoluto.
                    </Span>
                    <Span>
                      O atleta que perdeu a semifinal para o Campeão ficará em terceiro
                      lugar e o atleta que perdeu a semifinal para o Vice-Campeão ficará em
                      quarto lugar.
                    </Span>
                    <Span>
                      Para categoria com 3 lutadores, aplica-se a regra melhor de 3.
                      Em caso de WO de um atleta, os dois lutadores restantes na categoria disputarão a final.
                    </Span>
                  <Span>
                    A pesagem será realizada no dia do evento. O competidor deverá
                    apresentar documento oficial com foto no momento da pesagem.
                  </Span>
                  <Span>
                    A pesagem dos atletas serão realizadas antes do início da categoria.
                  </Span>
                  <Span>
                    Atletas que ultrapasarem o limite de peso da categoria que estiverem
                    inscritos serão automaticamente desclassificados e não poderão lutar o
                    Absoluto.
                  </Span>
                  <Span>
                    Afim de evitar chaves sem lutas o esquema de faixa usado
                    será o seguinte:
                  </Span>
                  <P> Branca; </P>
                  <P> Cinza e Amarela (juntas); </P>
                  <P> Laranja e Verde (juntas); </P>
                  <P> Azul; </P>
                  <P> Roxa; </P>
                  <P> Marrom; </P>
                  <P> Preta. </P> 
                  <Span> Será permitida a inscrição de atletas Juvenil na faixa Verde, porém
                    ele lutará como Juvenil faixa Azul.
                  </Span>

                  <Span>Será realizada apenas uma pesagem oficial por atleta.</Span>
                  <Span>
                    Teremos uma balança para pesagem livre (não oficial) para os atletas.
                  </Span>
                  <Span>Teremos duas balanças para pesagem oficial dos atletas.</Span>
                  {/* <Span>Teremos 4 (quatro) aréas de lutas</Span> */}
                  {/*  <Span>A Arbitragem será composta pela Equipe da Federação de Arbítrio do Amazonas</Span> */}
                  <Span>
                    Atletas que lutaram em outros eventos com faixa superior não poderão
                    lutar com a faixa abaixo. Se descoberto, o competidor será eliminado do
                    torneio sem direito a reembolso.
                  </Span>
                  <br />
                  {/* <H3>Pontuação por equipe</H3>
                  <H5>Categoria e Absoluto, todas as faixas</H5>
                  <P>1° lugar: 9 pontos</P>
                  <P>2° lugar: 3 pontos</P>
                  <P>3° lugar: 1 ponto</P>


                  <P>
                    A contagem dos pontos será realizada de forma geral contabilizando os
                    pontos de todas as faixas.
                  </P>
                  <P>Campeão direto não contam pontos, chaves com apenas um inscrito.</P>
                  <P>
                    Campeão por WO, devido a desistencia do oponente, contará pontos desde
                    que na chave tenha mais de um inscrito.
                  </P>
                  <P>
                    Categorias com atletas somente da mesma academia não contam pontos
                    para a disputa por academias, para contar pontos é necessário ao menos um
                    atleta de outra academia para validar a chave.
                  </P>
                  <br />
                  <H3>Para o absoluto:</H3>
                  <P>
                    Não será permitido luta combinada.
                  </P>
                  <P>
                    Não será permitido fechamento dos finalistas.
                  </P>
                  <P>
                    Não será permitido o atleta deixar de fazer o combate, afim de beneficiar o outro atleta.
                  </P>
                  <P>
                    Caso aconteça alguns desses itens acima ,  a organização fica sem a obrigação de fazer a entrega  da premiação  citado nesse edital.
                  </P> */}
                  <br />
                  <P>
                    O que não estiver neste edital, será acatado o que estiver no livro de
                    regras da CBJJ.
                  </P>
                  <br />
                  <P>
                    <a
                      target={"blank"}
                      href="https://cbjj.com.br/books-videos"
                      style={{ color: "white" }}
                    >
                      <strong>LIVRO DE REGRAS DA CBJJ/IBJJF</strong>
                    </a>
                  </P>
                </Collapse>
                <Collapse title={"CRONOGRAMA" + dataDeDivulgacaoCronograma + " " + horaDeDivulgacaoCCronograma}>
                
                  <Container>

                    <span>Cronograma Noroeste Open 2025</span>

                      <h4>Pré Mirim a Juvenil - GI 🥋</h4>
                      <h5>09:00 - Categoria Juvenil - Todas as faixas Masculino/Feminino (área de aquecimento)</h5>
                      <h5>09:10 - Abertura do evento</h5>
                      <h5>09:30 - Início do evento</h5>
                      <h5>09:50 - Pré Mirim e Mirim A - Todas as faixas Masculino/Feminino</h5>
                      <h5>10:10 - Mirim B - Todas as faixas Masculino/Feminino</h5>
                      <h5>10:30 - Infantil A - Todas as faixas Masculino/Feminino</h5>
                      <h5>10:50 - Infantil B - Todas as faixas Masculino/Feminino</h5>
                      <h5>11:10 - Infanto-Juvenil - Todas as faixas Masculino/Feminino</h5>
                      <h5>11:30 - Absolutos Juvenil - Masculino/Feminino</h5>

                      <h4>Pré Mirim a Juvenil - NO GI 🤼</h4>
                      <h5>11:50 - NO GI - Pré Mirim até Infantil A - Todas as faixas Masculino/Feminino</h5>
                      <h5>12:00 - NO GI - Infantil B e Infanto Juvenil - Todas as faixas Masculino/Feminino</h5>
                      <h5>12:20 - NO GI - Juvenil</h5>
                      <h5>13:20 - NO GI - Absoluto Juvenil</h5>

                      <h4>Adultos a Masters - GI 🥋</h4>
                      <h5>12:10 - Faixas Marrom e Preta - Adulto e Master - Masculino/Feminino</h5>
                      <h5>12:20 - Faixa Azul - Adulto e Master - Masculino/Feminino</h5>
                      <h5>12:40 - Faixa Roxa - Adulto e Master - Masculino/Feminino</h5>
                      <h5>13:00 - Faixa Branca - Adulto - Masculino/Feminino</h5>
                      <h5>13:20 - Faixa Branca - Masters - Masculino/Feminino</h5>
                      <h5>13:50 - Início dos Absolutos Adulto/Masters - Masculino/Feminino</h5>

                      <h4>Adultos a Masters - NO GI 🤼</h4>
                      <h5>14:40 - Faixas Marrom e Preta - Adulto e Master - Masculino/Feminino</h5>
                      <h5>14:50 - Faixa Azul - Adulto e Master - Masculino/Feminino</h5>
                      <h5>15:00 - Faixa Roxa - Adulto e Master - Masculino/Feminino</h5>
                      <h5>15:10 - Faixa Branca - Adulto e Masters - Masculino/Feminino</h5>
                      <h5>15:30 - Início dos Absolutos Adulto/Masters - Masculino/Feminino</h5>



                    <p><strong>Informações importantes:</strong></p>
                    <ul>
                      <li>Não haverá Absoluto Faixa Branca Masculino e Feminino NO GI</li>
                      <li>É proibido lutar a categoria NO GI sem rash guard.</li>
                      <li>As inscrições do Absoluto deverão ser feitas após o término das categorias.</li>
                      <li>Os absolutos serão disputados após o término das suas respectivas categorias.</li>
                      <li>O cronograma pode ser adiantado em até 1 hora, e atrasar conforme a necessidade do evento.</li>
                      <li>O atleta deverá estar presente no ginásio pelo menos 1 hora antes da sua luta.</li>
                      <li>O atleta que não estiver presente no momento da chamada para a pesagem ou luta será desclassificado por W.O.</li>
                      <li>A pesagem será feita antes da 1ª luta do atleta. Em caso de não bater o peso, o atleta será imediatamente desclassificado.</li>
                      <li>Será verificado também as condições do kimono do atleta antes da luta, podendo ocorrer desclassificação.</li>
                      <li>Todos os atletas devem estar 45 minutos antes do tempo de sua categoria na área de aquecimento, podendo lutar até 30 minutos antes do horário previsto no cronograma.</li>
                      <li>Para o que não estiver presente neste edital, seguiremos normas e regras da CBJJ.</li>
                    </ul>
                    <p><strong>Obs.:</strong> Desejamos a todos um excelente campeonato!</p>
                    <br />Ossssssssss
                  </Container>
                </Collapse>
                <Collapse title="ENTRADA">
                    <P>Entrada liberada ao público.</P>
                    <br />
                    {/* <P>
                  Será cobrado 1kg de alimento não perecível na entrada para atletas e
                  público.
                </P> */}
                    {/* <br />
                <P>Crianças até 5 anos ficam isentas de qualquer tipo de pagamento.</P>
                <br /> */}
                  </Collapse>
                <Collapse title="CONTATO">
                <P>Caso Precise falar com o responsável do evento, entre em contato por telefone ou WhatsApp.</P>
                <a target={"blank"} href="https://whatsa.me/5544997269732/?t=Ol%C3%A1%0A%0APreciso%20de%20ajuda%20com%20minha%20inscri%C3%A7%C3%A3o%20no%20*NOROESTE%20OPEN%20DE%20JIU%20JITSU%202025*"
                  >
                    <strong>Telefone/WhatsApp: {contatoWhatsApp} </strong>
                    <FaWhatsapp />
                  </a>
                  <br />
                  <br />
                  <P>
                    Dúvidas sobre cadastro, inscrição, pagamento, correção, checagem ou
                    sugestão de melhorias entre em contato com a equipe do Torneio Fácil
                    por telefone ou WhatsApp.
                  </P>
                  <P>Melhor horário para atendimento das 18:00h as 23:59h.</P>
                  <a
                    target={"blank"}
                    href="https://whatsa.me/5511944563515/?t=Olá%20Equipe%20Torneio%20Fácil!%0A%0APreciso%20de%20ajuda%20com%20minha%20inscri%C3%A7%C3%A3o%20no%20*OPEN%20DE%20JIU%20JITSU%202025*"
                  >
                    <strong>Telefone/WhatsApp: {contatoWhatsAppTorneio} </strong>
                    <FaWhatsapp />
                  </a>

                  <br />
                </Collapse>
              </EditalContainer>
            </Content>
            <br />
            <Content>
              {authenticated ? (
                <>
                  {/* <TournamentEnrollmentLinkEndpage to="/enrollment/ii-copa-arena-parintins-de-jiu-jitsu-arena-olimpica-rubens-dos-santos-gi">
                    Inscrição GI
                  </TournamentEnrollmentLinkEndpage>
                  <TournamentEnrollmentLinkEndpage to="/enrollment/ii-copa-arena-parintins-de-jiu-jitsu-arena-olimpica-rubens-dos-santos-nogi">
                    Inscrição NOGI
                  </TournamentEnrollmentLinkEndpage> */}

                  <TournamentEnrollmentLinkEndpage to={""} onClick={() => handleToSubscriptionPage(rotaInscriçãoGi)}>
                    Inscrição
                  </TournamentEnrollmentLinkEndpage>

                  <TournamentEnrollmentLinkEndpage to="/profile/subscription">
                    Correção da Inscrição
                  </TournamentEnrollmentLinkEndpage>
                </>
              ) : (
                <>
                  <TournamentEnrollmentLinkEndpage to="" onClick={() => handleToSubscriptionPage("/login")}>
                    Inscrição
                  </TournamentEnrollmentLinkEndpage>

                  <TournamentEnrollmentLinkEndpage to="/login">
                    Correção da Inscrição
                  </TournamentEnrollmentLinkEndpage>
                </>
              )}
              {/* <TournamentLink href="http://www.campeonatofacil.com/eventos/jj/main/mainall.asp?s=3.767B171E&u=teste" target="_blank">Chaves</TournamentLink> */}
              {/* // /check/16-COPA-PARANA-DE-JIU-JITSU */}

              <TournamentLink
                // target="_blank"
                href={rotaChecagemGi}
              >
                Checagem GI
              </TournamentLink>

               <TournamentLink
                // target="_blank"
                href={rotaChecagemNogi}
              >
                Checagem NOGI
              </TournamentLink> 

              {/* 
              <TournamentLink
                href="/check/toledo-international-open-brazilian-jiu-jitsu-nogi-2023-ginasio-de-esportes-alcides-pan-toledo-pr/search"
                target="_blank"
              >
                Checagem de atletas NO GI
              </TournamentLink>  */}

              <TournamentLink
                // target="_blank"
                href={rotaChavesGI}
              >
                Chaves GI
              </TournamentLink>
              <TournamentLink
                // target="_blank"
                href={rotaChavesNogi}
              >
                Chaves NOGI
              </TournamentLink>


              {/*               <TournamentLink
                href="http://www.campeonatofacil.com/eventos/jj/main/mainall.asp?s=3.5B5B1C9A&u=teste"
                target="_blank"
              >
                Chaves NO GI
              </TournamentLink> */}

              <TournamentLink target="blank" href={tabelaPeso}>
                Tabela de pesos
              </TournamentLink>
              {/* <TournamentLink href="#">Resultados (EM BREVE)</TournamentLink> */}
            </Content>
          </TournamentActions>
        </TournamentDescription>
      </Container>
      <Footer />
    </>
  );
};

export default NoroesteOpenDeJiuJitsu2025;
